// Add your custom JS here.


jQuery(document).ready(function ($) {

  $("#page.site").css("opacity", 1);
  
  // Initialize HLS videos
  initHLSVideos();

  $(window).scroll(function (event) {
    //moveEffect();
    menuSticky();
  });

  menuSticky();

  var mobile;
  // This will fire when document is ready:
  $(window).resize(function () {
    // This will fire each time the window is resized:
    if ($(window).width() >= 992) {
      // if larger or equal
      mobile = 0;
    } else {
      // if smaller
      mobile = 1;
    }
  }).resize(); // This will simulate a resize to trigger the initial run.

  function menuSticky() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 50) {
      //$("#top-nav").addClass("sticky-active");
      //$("#main-nav").addClass("sticky-active");
      $("#wrapper-navbar").addClass("sticky-active");

    } else {
      //$("#top-nav").removeClass("sticky-active");
      //$("#main-nav").removeClass("sticky-active");
      $("#wrapper-navbar").removeClass("sticky-active");
    }
  }

  if ($('.sticky-menu').length) {
    var stickyNavTop = $('.sticky-menu').offset().top - 123;
    var stickyNavTopEnd = $('.end-sticky-menu').offset().top - 123;

    var stickyNav = function () {
      var scrollTop = $(window).scrollTop();
      if ((scrollTop > stickyNavTop) && (scrollTop < stickyNavTopEnd)) {
        $('.sticky-menu').addClass('sticky-menu-active');

        $(".anchor-link-sticky").each(function (index) {
          var item = $(this).attr('data-target');
          console.log(item);
          var itemSelected = $(item);
          console.log(itemSelected);
          if (itemSelected[0].getBoundingClientRect().top > 130) {
            $(this).removeClass('active-section');
          } else {
            $('.active-section').removeClass('active-section');
            $(this).addClass('active-section');
          }
        });
      } else {
        $('.sticky-menu').removeClass('sticky-menu-active');
        $('.active-section').removeClass('active-section');
      }
    };

    stickyNav();
    // and run it again every time you scroll
    $(window).scroll(function () {
      stickyNav();
    });
  }

  // Validar que el menú realmente se abra/cierre antes de agregar/quitar la clase
  $('#navbarNavDropdown').on('show.bs.collapse', function () {
    // El menú está a punto de abrirse - agregar la clase inmediatamente
    $("#main-nav").addClass("mobile-menu-active");
  });

  $('#navbarNavDropdown').on('hide.bs.collapse', function () {
    // El menú está a punto de cerrarse - quitar la clase inmediatamente
    $("#main-nav").removeClass("mobile-menu-active");
  });
  
  // Validación adicional: si el menú ya está abierto al cargar, agregar la clase
  if ($('#navbarNavDropdown').hasClass('show') || $('#navbarNavDropdown').hasClass('collapsing')) {
    $("#main-nav").addClass("mobile-menu-active");
  }

  if (document.querySelector('.loader')) {
    window.addEventListener('scroll', findLoader);
  }

  $('#main-nav .dropdown-toggle').removeAttr('data-toggle');
  $('#main-nav .dropdown-toggle').removeAttr('data-bs-toggle');

  // Verificar si estamos en la página de búsqueda
  var isSearchPage = $('body').hasClass('search') || 
                     $('body').hasClass('search-results') ||
                     window.location.pathname.includes('/search') || 
                     (window.location.search && window.location.search.includes('?s='));

  $('#wrapper-navbar').on("mouseleave", function () {
    // En la página de búsqueda, mantener el search container visible y el menú activo
    if (isSearchPage) {
      // Cerrar los dropdowns del menú principal pero mantener el search container visible
      $("#main-menu .dropdown-toggle, #navbarNavDropdown .dropdown-toggle").removeClass("show");
      $("#main-menu .dropdown-menu, #navbarNavDropdown .dropdown-menu").removeClass("show");
      $("#main-menu .sub-dropdown, #navbarNavDropdown .sub-dropdown").removeClass('sub-dropdown-show');
      $("#main-menu .dropdown, #navbarNavDropdown .dropdown").removeClass("show");
      // Mantener el search container y el menú activo visible
      $("#dropdown-search-container").show();
      $("#main-nav").addClass("menu-active");
    } else {
      $("#main-nav").removeClass("menu-active");
      // Solo afectar al menú principal, no al top menu
      $("#main-menu .dropdown-toggle, #navbarNavDropdown .dropdown-toggle").removeClass("show");
      $("#main-menu .dropdown-menu, #navbarNavDropdown .dropdown-menu").removeClass("show");
      $("#main-menu .sub-dropdown, #navbarNavDropdown .sub-dropdown").removeClass('sub-dropdown-show');
      $("#main-menu .dropdown, #navbarNavDropdown .dropdown").removeClass("show");
      $("#dropdown-search-container").hide();
    }
  });

  // Solo aplicar hover al menú principal, no al top menu ni a los sub-dropdowns
  // Excluir explícitamente los sub-dropdowns del selector
  $('#main-menu > .nav-item.dropdown:not(.sub-dropdown), #navbarNavDropdown > .nav-item.dropdown:not(.sub-dropdown)').on('mouseenter', function (e) {
    // Prevenir que se dispare si el evento viene de un sub-dropdown o del dropdown-menu
    if ($(e.target).closest('.sub-dropdown').length || 
        ($(e.target).closest('.dropdown-menu').length && !$(e.target).closest('.dropdown-menu').is($(this).find('> .dropdown-menu')))) {
      return;
    }
    
    var $this = $(this);
    var $dropdownMenu = $this.find('> .dropdown-menu');
    
    // Si ya está abierto, no hacer nada para evitar glitches
    if ($this.hasClass('show') && $dropdownMenu.hasClass('show')) {
      return;
    }
    
    // No ocultar el search container si está activo (tiene la clase active)
    var searchIsActive = $('.search-form').hasClass('active');
    
    // Remove 'show' from all dropdowns del menú principal solamente, excepto el actual
    $("#main-menu > .nav-item.dropdown:not(.sub-dropdown), #navbarNavDropdown > .nav-item.dropdown:not(.sub-dropdown)").not($this).removeClass("show");
    $("#main-menu > .nav-item.dropdown:not(.sub-dropdown) .dropdown-toggle, #navbarNavDropdown > .nav-item.dropdown:not(.sub-dropdown) .dropdown-toggle").not($this.find('> .dropdown-toggle')).removeClass("show");
    $("#main-menu > .nav-item.dropdown:not(.sub-dropdown) .dropdown-menu, #navbarNavDropdown > .nav-item.dropdown:not(.sub-dropdown) .dropdown-menu").not($dropdownMenu).removeClass("show");

    // Add 'show' only to the hovered dropdown and its children
    $this.addClass('show');
    $this.find('> .dropdown-toggle').addClass('show');
    $dropdownMenu.addClass('show');
    $("#main-nav").addClass("menu-active");
    
    // Solo ocultar el search container cuando se despliega el menú si NO está activo
    if (!searchIsActive) {
      $("#dropdown-search-container").hide();
    }
  });

  // Mantener el dropdown abierto cuando el mouse está sobre el dropdown-menu
  $('#main-menu .dropdown-menu, #navbarNavDropdown .dropdown-menu').on('mouseenter', function (e) {
    e.stopPropagation(); // Prevenir que el evento se propague al padre
    
    var $menu = $(this);
    var $parent = $menu.parent('.dropdown, .nav-item');
    
    // Si el parent es un sub-dropdown, también mantener abierto el dropdown principal
    var $mainDropdown = $parent.closest('#main-menu > .nav-item.dropdown, #navbarNavDropdown > .nav-item.dropdown');
    
    // Asegurar que el dropdown padre permanezca abierto
    if ($parent.length) {
      $parent.addClass('show');
      $parent.find('> .dropdown-toggle').addClass('show');
    }
    if ($mainDropdown.length) {
      $mainDropdown.addClass('show');
      $mainDropdown.find('> .dropdown-toggle').addClass('show');
    }
    $menu.addClass('show');
    $("#main-nav").addClass("menu-active");
  });

  $('#dropdown-search-container').hover(function () {
    $(".sub-dropdown").removeClass('sub-dropdown-show');
  });

  if (mobile == 0) {
    $('.sub-dropdown').on('mouseenter', function (e) {
      e.stopPropagation(); // Prevenir que el evento se propague al dropdown principal
      
      var $this = $(this);
      
      // Mantener abierto el dropdown principal cuando se hace hover sobre un sub-dropdown
      var $mainDropdown = $this.closest('#main-menu > .nav-item.dropdown, #navbarNavDropdown > .nav-item.dropdown');
      if ($mainDropdown.length) {
        $mainDropdown.addClass('show');
        $mainDropdown.find('> .dropdown-toggle').addClass('show');
        $mainDropdown.find('> .dropdown-menu').addClass('show');
        $("#main-nav").addClass("menu-active");
      }
      
      // Si ya está abierto, no hacer nada para evitar glitches
      if ($this.hasClass('sub-dropdown-show')) {
        return;
      }
      
      // Remove 'sub-dropdown-show' from all sub-dropdowns except the current one
      $(".sub-dropdown").not($this).removeClass('sub-dropdown-show');
      
      // Add 'sub-dropdown-show' only if it doesn't have it already
      if (!$this.hasClass('sub-dropdown-show')) {
        $this.addClass('sub-dropdown-show');
      }
    });
  } else {
    $('.sub-dropdown .fa').click(function (e) {
      e.preventDefault();
      if ($(this).parent().parent().hasClass('sub-dropdown-show')) {
        $(this).parent().parent().removeClass('sub-dropdown-show');
      } else {
        $(this).parent().parent().addClass('sub-dropdown-show');
      }
    });
  }

  // Si estamos en la página de búsqueda, mostrar el search container al cargar
  if (isSearchPage) {
    $("#dropdown-search-container").show();
    $("#main-nav").addClass("menu-active");
  }

  // Obtener el valor del parámetro ?s= de la URL y establecerlo en el input
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Establecer el valor de búsqueda si existe en la URL
  var searchValue = getUrlParameter('s');
  if (searchValue) {
    $('#search-form-dropdown').val(searchValue);
    // Mostrar el icono de cerrar si hay valor
    if (searchValue.length > 0) {
      $('.search-clear-icon').show();
    }
  }

  $('header .search-form, header .icon-search').click(function (event) {
    event.stopPropagation();
    event.preventDefault();
    
    // Abrir el dropdown de búsqueda y activar el menú
    $("#dropdown-search-container").show();
    $("#main-nav").addClass("menu-active");
    
    // Agregar clase active al formulario y al input
    $('.search-form').addClass('active');
    $('.search-form__input').addClass('active');
    
    // Enfocar el input del dropdown después de un pequeño delay
    setTimeout(function() {
      $('#search-form-dropdown').focus();
    }, 100);
  });

  $(document).on("click", function (e) {
    // No ejecutar si el click fue en el icono de cerrar o en el search container
    if ($(e.target).closest('.search-clear-icon, #dropdown-search-container').length) {
      return;
    }
    $('header .search-form__input').removeClass('active');
    $('header .search-form').removeClass('active');
  });

  // Funcionalidad del icono de cerrar en el campo de búsqueda del dropdown
  $(document).on('mousedown touchstart', '.search-clear-icon', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    var $icon = $(this);
    var $form = $icon.closest('form');
    var $input = $form.find('input[type="search"], input[name="s"]');
    
    if ($input.length === 0) {
      $input = $('#search-form-dropdown');
    }
    
    if ($input.length > 0 && $input[0]) {
      // Obtener referencia directa al elemento DOM
      var inputElement = $input[0];
      
      // Limpiar el valor de todas las formas posibles
      inputElement.value = '';
      inputElement.setAttribute('value', '');
      inputElement.removeAttribute('value');
      $input.val('');
      $input.removeAttr('value');
      
      // Forzar actualización del DOM
      $input.trigger('input');
      $input.trigger('change');
      $input.trigger('keyup');
      
      // Ocultar el icono
      $icon.hide();
      
      // Mantener el foco en el input
      setTimeout(function() {
        inputElement.focus();
        // Verificar nuevamente después del timeout
        if (inputElement.value !== '') {
          inputElement.value = '';
          $input.val('');
        }
      }, 50);
    }
    
    return false;
  });
  
  // Prevenir que el click en el icono envíe el formulario
  $(document).on('click', '.search-clear-icon', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });
  
  // Prevenir submit del form cuando se hace click en el icono
  $('#searchForm').on('submit', function(e) {
    if ($(e.originalEvent && e.originalEvent.submitter).hasClass('search-clear-icon')) {
      e.preventDefault();
      return false;
    }
  });

  // Mostrar/ocultar el icono de cerrar según si hay texto
  $(document).on('input', '#search-form-dropdown', function() {
    if ($(this).val().length > 0) {
      $('.search-clear-icon').show();
    } else {
      $('.search-clear-icon').hide();
    }
  });


  $('.filter .filter-button').on('click', function () {
    var filterContainer = $(this).closest('.filter');
    var target = filterContainer.data('target');
    //console.log(target);
    if (target) {
      $('html, body').animate({
        scrollTop: $("#filter-result").offset().top
      }, 500);
    }
    var filterUsed = $(this).closest('.filter-container');
    var search2all = false;
    if ($(this).hasClass('active')) {
      if ($(this).hasClass('filter-color-item')) {
        filterUsed.find('.filter-button').removeClass('active');
        search2all = true;
      }
    } else {
      filterUsed.find('.filter-button').removeClass('active');
      $(this).addClass('active');
    }
    var search, search2;
    if (filterUsed.hasClass('filter-lrv')) {
      search = $(this).data('filter');
      console.log(search);
      search2 = filterContainer.find('.filter-color').find('.filter-button.active').data('filter-color');
    } else if (filterUsed.hasClass('filter-color')) {
      search2 = $(this).data('filter-color');
      search = filterContainer.find('.filter-lrv').find('.filter-button.active').data('filter');
    } else {
      search = $(this).data('filter');
      console.log(search);
    }
    // Determine the container to search for filter items
    var itemsContainer = filterContainer.find('.filter-item').length > 0 
      ? filterContainer 
      : $('body');
    
    if ((search2 == null) || (search2all == true)) {
      if (search == 'all') {
        itemsContainer.find('.filter-item').show();
      } else {
        itemsContainer.find('.filter-item[data-filter]').each(function () {
          var values = $(this).data('filter');
          if (values && typeof values === 'string' && values.includes(search)) {
            $(this).show();
          } else if (values && Array.isArray(values) && values.indexOf(search) !== -1) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      }
    } else {
      itemsContainer.find('.filter-item[data-filter]').each(function () {
        var values = $(this).data('filter');
        var values2 = $(this).data('filter-color');
        if (values2 == undefined) {
          values2 = "";
        }
        if (values == undefined) {
          values = "";
        }
        if (search == 'all') {
          if (values2 && values2.includes(search2)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        } else {
          var valuesStr = typeof values === 'string' ? values : (Array.isArray(values) ? values.join(',') : '');
          var values2Str = typeof values2 === 'string' ? values2 : (Array.isArray(values2) ? values2.join(',') : '');
          if (valuesStr && valuesStr.includes(search) && values2Str && values2Str.includes(search2)) {
            $(this).show();
          } else {
            $(this).hide();
          }
        }
      });
    }
  })

  if ($('body.page-template-insigths').length > 0) {
    var search = window.location.hash.substring(1);
    if (search) {
      $('.filter .filter-button').removeClass('active');
      $('.filter .filter-button[data-filter=' + search + ']').addClass('active');
      $('.filter-item[data-filter]').each(function () {
        var values = $(this).data('filter');
        if (values.includes(search))
          $(this).show();
        else
          $(this).hide();
      });
      $('html, body').animate({
        scrollTop: $("#filter-result").offset().top
      }, 500);
    }
  }

  if ($('body.page-template-projects').length > 0) {
    var search = window.location.hash.substring(1);
    if (search) {
      $('.filter .filter-button').removeClass('active');
      $('.filter .filter-button[data-filter=' + search + ']').addClass('active');
      $('.filter-item[data-filter]').each(function () {
        var values = $(this).data('filter');
        if (values.includes(search))
          $(this).show();
        else
          $(this).hide();
      })
    }
  }

  $('#whatDescribesYou').change(function (e) {
    var option = $(this).val();
    if (option == 'Other') {
      $('#whatDescribesYouOther').show();
    } else {
      $('#whatDescribesYouOther').hide();
    }
  });

  var screenHeight = window.innerHeight;
  var screenHeightHalf = screenHeight / 2;
  var movefrom;
  var movefromNew;
  var movefromHeight;
  var movefromOffsetMid;
  var movefromOffset;
  var movement = (screenHeight / 100);
  var position = $(window).scrollTop();

  $('.xxx-move-vertical-from').each(function () {
    movefrom = this.getBoundingClientRect().top;
    movefromHeight = this.getBoundingClientRect().height;
    movefromOffset = $(this).offset().top;
    movefromOffsetMid = movefromOffset + (movefromHeight / 2);
  });

  $('.xxx-move-vertical-2').each(function () {
    this.element = this.getBoundingClientRect().top;
    this.elementHeight = this.getBoundingClientRect().height;
    this.elementOffset = $(this).offset().top;
    this.elementOffsetMid = this.elementOffset + (this.elementHeight / 2);
    this.translateYInitial = movefromOffsetMid - this.elementOffsetMid;

    this.translateY = position - this.elementOffsetMid;

    if (this.translateY < this.translateYInitial) {
      this.translateY = this.translateYInitial;
    }

    if (this.translateY > 0) {
      this.translateY = 0;
    }

    if ($(this).hasClass('move-horizontal-2')) {
      this.translateX = 30 - (30 / this.translateY);
      $(this).css({ transform: 'translate(' + this.translateX + 'px,' + this.translateY + 'px)' });
      //console.log("tiene"+this.translateX);
    } else {
      $(this).css({ transform: 'translate(0,' + this.translateY + 'px)' });
      //console.log("no tiene");
    }

  });

  //moveEffect();

  function findLoader() {
    var loader = document.querySelector('.loader');
    var position = loader.getBoundingClientRect().top;
    if (position < screenHeightHalf) {
      $(loader).css('opacity', 1);
      setTimeout(() => {
        loader.style.opacity = 0;
        $('.video-item').show();
        $(loader).hide();
        window.removeEventListener('scroll', findLoader);
      }, "1000");
    }
  }

  function moveEffect() {

    position = $(window).scrollTop();

    $('.move-vertical-from').each(function () {
      movefromNew = this.getBoundingClientRect().top;
    });

    $('.move-vertical-2').each(function () {
      this.elementNew = this.getBoundingClientRect().top;
      this.elementHeightNew = this.getBoundingClientRect().height;
      this.elementOffsetNew = $(this).offset().top;
      this.elementOffsetMidNew = this.elementOffsetNew + (this.elementHeightNew / 2);

      this.translateY = position - this.elementOffset + 200;

      if (this.translateY < this.translateYInitial) {
        this.translateY = this.translateYInitial;
      }

      if (this.translateY > 0) {
        this.translateY = 0;
      }

      //console.log(this.translateY);
      if ($(this).hasClass('move-horizontal-2')) {
        this.translateX = -1 * ((30 / this.elementHeightNew) * this.translateY);

        $(this).css({ transform: 'translate(' + this.translateX + 'px,' + this.translateY + 'px)' });
        //console.log("tiene"+this.translateX);
      } else {
        $(this).css({ transform: 'translate(0,' + this.translateY + 'px)' });
        //console.log("no tiene");
      }

    });

    $('.move-vertical-xs').each(function () {
      this.previousTranslateY = this.currentTranslateY;
      this.currentTranslateY = window.scrollY;
      this.screenHeight = window.innerHeight;
      var positionOfElement0 = this.getBoundingClientRect().top * 2; //* change the begin and end
      this.translateY = (-1 * (positionOfElement0 / (movement * 4)));
      $(this).css({ transform: 'translateY(calc(' + this.translateY + 'px)' });
    });

    $('.move-horizontal').each(function () {
      this.previousTranslateY = this.currentTranslateY;
      this.currentTranslateY = window.scrollY;
      this.screenHeight = window.innerHeight;
      var positionOfElement0 = this.getBoundingClientRect().top * 1.5; //* change the begin and end 1.5
      var heightOfElement0 = this.getBoundingClientRect().height;
      var halfHeightOfElement0 = (heightOfElement0 * .5);
      this.translateY = ((positionOfElement0 - halfHeightOfElement0) / (movement * 4)); // /4
      this.translateY = (this.translateY < 0) ? this.translateY * -1 : this.translateY;
      if ($(this).hasClass("out-left")) {
        this.translateY = (this.translateY * -1);
      }
      if (this.translateY < -50) {
        this.translateY = -50;
      } else if (this.translateY > 50) {
        this.translateY = 50;
      }
      $(this).css({ transform: 'translateX(' + this.translateY + '%)' }); //px
    });

  }

  // Initialize Vimeo players
  function initVimeoPlayers() {
    // Check if Vimeo API is loaded
    if (typeof Vimeo === 'undefined') {
      console.warn('Vimeo API not loaded yet, retrying...');
      setTimeout(initVimeoPlayers, 100);
      return;
    }

    $('.grid-videos .video').each(function () {
      var $video = $(this);
      var $iframe = $video.find('.vimeo-iframe');
      
      // Check if iframe exists and has a valid Vimeo URL
      if ($iframe.length && $iframe.attr('src') && $iframe.attr('src').includes('vimeo.com')) {
        try {
          var player = new Vimeo.Player($iframe[0]);
          
          // Store player reference
          $video.data('vimeoPlayer', player);
          
          $video.hover(function () {
            var playerInstance = $(this).data('vimeoPlayer');
            if (playerInstance) {
              playerInstance.play();
            }
          }, function () {
            var playerInstance = $(this).data('vimeoPlayer');
            if (playerInstance) {
              playerInstance.pause();
            }
          });
        } catch (error) {
          console.warn('Vimeo Player initialization failed:', error);
        }
      }
    });
  }

  // Initialize Vimeo players if grid-videos exists
  if ($('.grid-videos').length) {
    initVimeoPlayers();
  }

  $('.btn-copy').on("click", function () {
    var value = $(this).attr('data-copy');
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();
    $(this).append("<span class='copied'>Copied</span>");
    setTimeout(function () {
      $(".copied").remove();
    }, 3000);
  })

  $(".anchor-link").click(function (e) {
    e.preventDefault();
    var target = $(this).attr("data-target");
    console.log(target);

    if ($(this).hasClass('anchor-link-sticky')) {
      $('html,body').animate({
        scrollTop: $(target).offset().top - 123
      }, 'slow');
    } else {
      $('html,body').animate({
        scrollTop: $(target).offset().top - 50
      }, 'slow');
    }

  });

  $(".btn-expand").click(function () {
    $(this).closest(".grid-container").addClass("expand");
  });

  $(".btn-collapse").click(function () {
    $(this).closest(".grid-container").removeClass("expand");
  });

  $(".flip, .flip-btn").click(function (e) {
    $(this).closest(".instagram-item").toggleClass('active');
  });

  // on radio button change(click)
  $(document).on('change', '.rudr-variation-radios input', function () {
    // for each checked radio button we reflect the same changes to select dropdowns
    $('.rudr-variation-radios input:checked').each(function (index, element) {
      const radio = $(element)
      const radioName = radio.attr('name')
      const radioValue = radio.attr('value')
      $('select[name="' + radioName + '"]').val(radioValue).trigger('change');
    })
  })


  if ($('body.page-template-product').length > 0) {

    $(".custom-add-popup").click(function (e) {
      e.preventDefault();
      var product_id = $(this).attr("data-product_id");
      $(this).addClass('active');
      $(".product-popup[data-product_id='" + product_id + "'").css('display', 'flex');
    });

    $('.product-popup').on('click', function (e) {
      if (e.target !== this)
        return;
      $(".product-popup").fadeOut();
    });

    $('body').on('added_to_cart', function () {
      $(".product-popup").fadeOut();
    });

    $(".custom-add-ajax").click(function (e) {
      e.preventDefault();
      var product_id = $(this).attr("data-product_id");

      var data = {
        product_id: product_id,
        quantity: 1,
      };
      var t = $(this);

      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: data,
        beforeSend: function () {
          console.log("entro");
          t.addClass("loading");
        },
        success: function (response) {
          t.removeClass("loading");
          t.addClass("added");
          // Refresh cart items counter and mini-cart widget
          $(document.body).trigger('wc_fragment_refresh');
        },
        error: function (error) {
          console.log(error);
        }
      });
    });
  }

  if ($('body.page-template-instagram').length > 0) {

    $("input:radio[name=attribute_aesthetic-4], input:radio[name=attribute_profile-4]").change(function () {
      var val1 = $("input:radio[name=attribute_aesthetic-4]:checked").val();
      var val2 = $("input:radio[name=attribute_profile-4]:checked").val();
      if ((val1 == "Embossed") && (val2 == "Rabbeted")) {
        $(this).closest(".add-to-cart-container").find(".single_add_to_cart_button").addClass("disabled");
      } else {
        $(this).closest(".add-to-cart-container").find(".single_add_to_cart_button").removeClass("disabled");
      }
    });

    $('.popup-variation').on('click', function (e) {
      if (e.target !== this)
        return;
      $(".popup-variation").fadeOut();
    });

    $(".instagram-popup").click(function (e) {
      e.preventDefault();
      var product_id = $(this).attr("data-product_id");
      $(this).addClass('active');
      $(".popup-variation[data-product_id='" + product_id + "'").css('display', 'flex');
    });

    $(".add-samples").click(function (e) {
      $(".popup-variation").fadeOut();
    });
    /*
        $(".wpcf7-submit.disabled").click(function (e) {
          $(".popup-variation").fadeIn();
        });    
    */
    $(".instagram-add").click(function (e) {
      e.preventDefault();
      var product = $(this).attr("data-product");
      var currentValue = $('#00NHs00001PfuEg').val();
      $('#00NHs00001PfuEg').val(currentValue + ' - ' + product);
      $(this).html("ADDED");
      $(this).addClass("disabled");
      $(".wpcf7-submit").removeClass('disabled');
    });

    $(".instagram-add-variable-trim").click(function (e) {
      e.preventDefault();
      var product = $(this).attr("data-product");
      var val1 = $("input:radio[name=attribute_aesthetic-4]:checked").val();
      var val2 = $("input:radio[name=attribute_profile-4]:checked").val();
      var currentValue = $('#00NHs00001PfuEg').val();
      $('#00NHs00001PfuEg').val(currentValue + ' - ' + product + ' ' + val1 + ' ' + val2);
      $('.instagram-popup[data-product_id=1856]').html("ADDED");
      $('.instagram-popup[data-product_id=1856]').addClass("disabled");
      $(".wpcf7-submit").removeClass('disabled');
      $(".popup-variation").fadeOut();
    });

    $(".instagram-add-variable-decking").click(function (e) {
      e.preventDefault();
      var product = $(this).attr("data-product");
      var val1 = $("input:radio[name=attribute_aesthetic-3]:checked").val();
      var val2 = $("input:radio[name=attribute_profile-3]:checked").val();
      var currentValue = $('#00NHs00001PfuEg').val();
      $('#00NHs00001PfuEg').val(currentValue + ' - ' + product + ' ' + val1 + ' ' + val2);
      $('.instagram-popup[data-product_id=1858]').html("ADDED");
      $('.instagram-popup[data-product_id=1858]').addClass("disabled");
      $(".wpcf7-submit").removeClass('disabled');
      $(".popup-variation").fadeOut();
    });

  }

  if ($('body.page-template-rebate, body.page-template-rebate-new').length > 0) {

    $("#form_pv").prop("disabled", true);
    $("#form_receipt").prop("disabled", true);
    $("#form_submit").prop("disabled", true);

    let porc = 0;
    let max = 0;
    let amount = 0;
    let earn = 0;
    let earn2 = 0;

    $("#form_prof input").change(function () {

      if (this.value == 'Yes') {
        porc = 0.05;
        max = 1000;
        calcRebate();
        $("#form_pv").prop("disabled", false);
        $("#form_receipt").prop("disabled", false);
        $("#form_submit").prop("disabled", false);
      } else if ((this.value == 'Builder/Contractor') || (this.value == 'Homeowner') || (this.value == 'Retail Salesperson')) {
        porc = 0.05;
        max = 1000;
        calcRebate();
        $("#form_pv").prop("disabled", false);
        $("#form_receipt").prop("disabled", false);
        $("#form_submit").prop("disabled", false);
      } else {
        $("#form_pv").prop("disabled", true);
        $("#form_receipt").prop("disabled", true);
        $("#form_submit").prop("disabled", true);
        $("#form_pv").val("$0");
        calcRebate();
      }
    });
    $("#form_pv").focusout(function () {
      calcRebate();
    });
    function calcRebate() {
      amount = $("#form_pv").val();
      earn = (amount * porc);
      if (earn > max) {
        earn = max;
      }
      earn2 = earn.toFixed(2);
      $("#form_rar, #form_rar2").val("$" + earn2);
    }
  }

  // FAQ Search Functionality
  (function () {
    var searchTimeout;
    var $searchInput = $('#faq-search-input');
    var $faqGroups = $('.faq-group');
    var $noResults = $('.no-results');
    var $accordionItems = $('.accordion-item');

    if ($searchInput.length) {
      $searchInput.on('input', function () {
        var searchTerm = $(this).val().trim().toLowerCase();

        // Clear previous timeout
        clearTimeout(searchTimeout);

        if (searchTerm.length == 0) {
          showAllFAQs();
          return;
        }

        // If search term is less than 3 characters, show all FAQs
        if (searchTerm.length < 3) {
          return;
        }

        // Set timeout for 0.5 seconds (500ms)
        searchTimeout = setTimeout(function () {
          performSearch(searchTerm);
        }, 500);
      });

      // Function to show all FAQs
      function showAllFAQs() {
        $faqGroups.show();
        $accordionItems.show();
        $noResults.hide();
      }

      // Function to perform the search
      function performSearch(searchTerm) {
        var hasResults = false;

        $faqGroups.each(function () {
          var $group = $(this);
          var groupHasResults = false;

          $group.find('.accordion-item').each(function () {
            var $item = $(this);
            var $question = $item.find('.accordion-button').text().toLowerCase();
            var $answer = $item.find('.accordion-body').text().toLowerCase();

            // Check if search term exists in question or answer (exact match)
            if ($question.includes(searchTerm) || $answer.includes(searchTerm)) {
              $item.show();
              groupHasResults = true;
              hasResults = true;
            } else {
              $item.hide();
            }
          });

          // Show/hide the group based on whether it has matching results
          if (groupHasResults) {
            $group.show();
          } else {
            $group.hide();
          }
        });

        // Show/hide no results message
        if (hasResults) {
          $noResults.hide();
        } else {
          $noResults.show();
        }
      }
    }
  })();


  
  // Slider Projects - Splide
  function initSliderProjects() {
    const sliderElement = document.getElementById('slider-projects');

    if (!sliderElement) {
      console.log('Slider element not found');
      return false;
    }

    // Check if Splide is required (element has .splide class)
    if (!sliderElement.classList.contains('splide')) {
      console.log('Slider element does not require Splide library');
      return false;
    }

    // Check if slider is already initialized
    if (sliderElement.classList.contains('splide--initialized')) {
      console.log('Slider already initialized');
      return true;
    }

    if (typeof Splide === 'undefined') {
      console.log('Splide library not loaded yet');
      return false;
    }

    console.log('Slider found, initializing Splide...');
    try {
      const splide = new Splide('#slider-projects', {
        //type: 'loop',
        //focus: 'center',   // mantiene el slide centrado
        gap: '0',     // separación entre slides en desktop
        pagination: false,      // opcional
        arrows: false,        // flechas activadas
        perMove: 1,           // mueve de a uno
        autoplay: true,        // activa el autoplay
        interval: 4000,        // tiempo entre slides (5 segundos) - aumenta para más lento
        speed: 1000,          // velocidad de transición (1 segundo) - aumenta para más lento
        pauseOnHover: true,    // pausa al hacer hover
        pauseOnFocus: true,    // pausa al tener foco
        trimSpace: true,      // permite ver slides parciales a los lados
        updateOnMove: true,    // actualiza las clases mientras se mueve
        snap: true,           // fuerza ajuste a slide completo al hacer drag 
        flickPower: 300,      // reduce la potencia del flick para más control
        fixedWidth: '305px',
        breakpoints: {
          1800: {
            fixedWidth: '20vw',
          },
          1200: {
            fixedWidth: '275px',
            type: 'loop',
            focus: 'center',
          },
          767: {
            fixedWidth: '245px',
            gap: '0', // separación entre slides en mobile/tablet
          }
        }
      });

      splide.mount();

      // Forzar recálculo inicial para centrado correcto
      setTimeout(function () {
        splide.refresh();
      }, 100);

      document.addEventListener('mouseenter', function (e) {
        if (e.target && e.target.closest && e.target.closest('.slider-projects .splide__slide')) {
          const slider = document.querySelector('.slider-projects');
          if (slider) {
            slider.classList.add('remove-effect');
          }
        }
      }, true);

      console.log('Splide initialized successfully');
      return true;
    } catch (error) {
      console.error('Error initializing Splide:', error);
      return false;
    }
  }

  // Function to wait for Splide library to load
  function waitForSplide(callback, maxAttempts = 100) {
    let attempts = 0;
    const checkSplide = () => {
      attempts++;
      if (typeof Splide !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkSplide, 50); // Check every 50ms instead of 100ms
      } else {
        console.error('Splide library failed to load after maximum attempts');
        console.error('Please check if Splide CDN is accessible and script is loading correctly');
      }
    };
    checkSplide();
  }

  // Initialize slider when DOM is ready
  function initializeSlider() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        waitForSplide(initSliderProjects);
      });
    } else {
      waitForSplide(initSliderProjects);
    }
  }

  // Helper function to check if page needs Splide
  function pageNeedsSplide() {
    const splideElements = document.querySelectorAll('.splide');
    if (splideElements.length > 0) {
      console.log('Found ' + splideElements.length + ' Splide element(s) on page');
      return true;
    }
    console.log('No Splide elements found on this page');
    return false;
  }

  // Start initialization
  if (pageNeedsSplide()) {
    initializeSlider();
  } else {
    console.log('Skipping Splide initialization - not required on this page');
  }

  // Initialize dynamic samples when DOM is ready
  $(document).ready(function () {
    initDynamicSamples();
    initImageExpansion();
    initAddToCart();
    initNewsSlider();
    initLogosSlider();
    initInspirationGallerySlider();
    initBuildingRevolution();
    initWoodPanelsScroll();
  });

  // Dynamic Sample Display Functionality for Samples Grid
  function initDynamicSamples() {
    // Handle sample image hover
    $(document).on('mouseenter', '.sample-click', function (e) {
      e.preventDefault();

      const $sampleItem = $(this).closest('.sample-item');
      const imageUrl = $sampleItem.data('image');
      const description = $sampleItem.data('description');
      const title = $sampleItem.data('title');

      // Get secondary data attributes
      const imageUrl2 = $sampleItem.data('image-2');
      const description2 = $sampleItem.data('description-2');
      const title2 = $sampleItem.data('title-2');

      // Update the dynamic display
      updateSampleDisplay(imageUrl, title, description, imageUrl2, title2, description2);

      // Add visual feedback
      $('.sample-item').removeClass('active');
      $sampleItem.addClass('active');
    });

    // Initialize with first sample
    const $firstSample = $('.sample-item').first();
    if ($firstSample.length) {
      const imageUrl = $firstSample.data('image');
      const description = $firstSample.data('description');
      const title = $firstSample.data('title');

      // Get secondary data attributes
      const imageUrl2 = $firstSample.data('image-2');
      const description2 = $firstSample.data('description-2');
      const title2 = $firstSample.data('title-2');

      updateSampleDisplay(imageUrl, title, description, imageUrl2, title2, description2);
      $firstSample.addClass('active');
    }
  }

  function updateSampleDisplay(imageUrl, title, description, imageUrl2, title2, description2) {
    const $image = $('#dynamic-sample-image');
    const $text = $('#dynamic-sample-text');

    if ($image.length && $text.length) {
      // Update image instantly
      $image.attr('src', imageUrl).attr('alt', title);

      // Update text
      // Validate that title and description are not empty before updating
      if (title && description) {
        $text.html(`${title}<span class="px-4">|</span>${description}`);
      } else if (title) {
        $text.html(title);
      } else if (description) {
        $text.html(description);
      } else {
        $text.html('');
      }

      console.log('Sample updated:', { imageUrl, title, description });
    }

    // Update secondary display elements
    const $image2 = $('.dynamic-sample-image-2');
    const $title2 = $('.dynamic-sample-title-2');
    const $description2 = $('.dynamic-sample-description-2');

    if ($image2.length && imageUrl2) {
      // Update image instantly
      $image2.attr('src', imageUrl2).attr('alt', title2);
    }

    if ($title2.length && title2) {
      $title2.text(title2);
    }

    if ($description2.length && description2) {
      $description2.text(description2);
    }

    if (imageUrl2 || title2 || description2) {
      console.log('Sample 2 updated:', { imageUrl2, title2, description2 });
    }
  }

  // Laurel Image Expansion Functionality
  function initImageExpansion() {
    // Handle expand button click
    $(document).on('click', '#expand-image-btn', function (e) {
      e.preventDefault();

      const $section = $(this).closest('.wpo-parallax');
      $section.toggleClass('expanded');

      const $label = $(this).find('.btn-label');
      $label.text($section.hasClass('expanded') ? 'Close' : 'Expand');
    });

  }

  // Add to Cart Functionality
  function initAddToCart() {
    // Handle add to cart button clicks
    $(document).on('click', '.ajax_add_to_cart[data-product_id]', function (e) {
      e.preventDefault();

      const productId = $(this).data('product_id');
      const $button = $(this);
      const originalText = $button.text();

      if (!productId) {
        console.error('Product ID not found');
        return;
      }

      // Add loading state
      $button.addClass('loading').find('.btn-label').text('Adding...');

      // Prepare AJAX data
      const ajaxData = {
        product_id: productId,
        quantity: 1,
        action: 'add_to_cart'
      };

      // Make AJAX request
      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
        data: ajaxData,
        success: function (response) {
          console.log('Product added to cart:', response);

          // Remove loading state
          $button.removeClass('loading').find('.btn-label').text('Added!');

          // Update button appearance
          $button.addClass('added');

          // Trigger cart update events
          $(document.body).trigger('wc_fragment_refresh');
          $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);

          // Reset button after 2 seconds
          setTimeout(function () {
            $button.removeClass('added').find('.btn-label').text(originalText);
          }, 2000);

        },
        error: function (xhr, status, error) {
          console.error('Error adding to cart:', error);

          // Remove loading state and show error
          $button.removeClass('loading').find('.btn-label').text('Error');

          // Reset button after 2 seconds
          setTimeout(function () {
            $button.text(originalText);
          }, 2000);
        }
      });
    });

    // Handle WooCommerce add to cart events
    $(document.body).on('added_to_cart', function (event, fragments, cart_hash, $button) {
      console.log('Product successfully added to cart');

      // Update cart fragments if available
      if (fragments) {
        $.each(fragments, function (key, value) {
          $(key).replaceWith(value);
        });
      }
    });
  }

});


(function () {
  // Si hay soporte nativo, el CSS hará el efecto.
  var supportsScrollTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()');
  if (supportsScrollTimeline) return;

  var sections = Array.from(document.querySelectorAll('.wpo-parallax'));
  if (!sections.length) return;

  var ticking = false;

  function readSpeed(el, def) {
    var v = getComputedStyle(el).getPropertyValue('--speed').trim();
    var n = parseFloat(v);
    return Number.isFinite(n) ? n : def;
  }

  function update() {
    var vh = window.innerHeight;

    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (sec.classList.contains('expanded')) continue; // no mover en expand

      var bg = sec.querySelector('.wpo-parallax__bg');
      if (!bg) continue;

      var r = sec.getBoundingClientRect();
      var speed = readSpeed(sec, 0.35); // ajustable por sección: style="--speed:0.35"
      var progress = (r.top - vh) / (r.height + vh);
      var offset = progress * r.height * speed;

      bg.style.transform = 'translateY(' + offset + 'px)';
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update, { once: true });
  } else {
    update();
  }
})();

// Logos Slider Functionality
function initLogosSlider() {
  const logosSliderElement = document.querySelector('#logos-slider');
  
  if (!logosSliderElement) {
    console.log('Logos slider element not found on this page');
    return;
  }
  
  // Check if Splide is required (element has .splide class)
  if (!logosSliderElement.classList.contains('splide')) {
    console.log('Logos slider element does not require Splide library');
    return;
  }
  
  console.log('Logos slider element found, waiting for Splide...');
  
  // Wait for Splide to be available
  const waitForSplide = (callback, maxAttempts = 100) => {
    let attempts = 0;
    const checkSplide = () => {
      attempts++;
      if (typeof Splide !== 'undefined') {
        console.log('Splide library loaded successfully for logos slider');
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkSplide, 50);
      } else {
        console.error('Splide library not loaded after maximum attempts for logos slider');
        console.error('Please verify Splide is enqueued in functions.php');
      }
    };
    checkSplide();
  };

  waitForSplide(() => {
    try {
      const logosSplide = new Splide('#logos-slider', {
          type: 'loop',
          focus: 'center',
          fixedWidth: '200px',
          gap: '40px',
          pagination: false,
          arrows: false,
          perMove: 1,
          autoplay: true,
          interval: 3000,
          speed: 1000,
          pauseOnHover: true,
          pauseOnFocus: true,
          trimSpace: false,
          updateOnMove: true,
          snap: true,
          flickPower: 200,

          breakpoints: {
            767: {
              fixedWidth: '150px',
              gap: '20px',
            }
          }
        });

    logosSplide.mount();
    console.log('Logos slider initialized successfully');
  } catch (error) {
    console.error('Error initializing logos slider:', error);
  }
});
}


// News Slider Functionality
function initNewsSlider() {
  const newsSliderElement = document.querySelector('#news-slider');
  
  if (!newsSliderElement) {
    console.log('News slider element not found on this page');
    return;
  }
  
  // Check if Splide is required (element has .splide class)
  if (!newsSliderElement.classList.contains('splide')) {
    console.log('News slider element does not require Splide library');
    return;
  }
  
  if (typeof Splide === 'undefined') {
    console.error('Splide library not loaded for news slider');
    console.error('Please verify Splide is enqueued in functions.php');
    return;
  }
  
  console.log('News slider element found, initializing...');
  
  try {
    const newsSplide = new Splide('#news-slider', {
        type: 'loop',
        perPage: 5, // Mostrar 3 slides completos
        gap: '40px',
        pagination: true,
        arrows: false,
        perMove: 1,
        autoplay: true,
        interval: 4000,
        speed: 800,
        pauseOnHover: true,
        pauseOnFocus: true,
        padding: 0, // Sin padding para evitar slides cortados
        updateOnMove: true,
        snap: true,
        flickPower: 200,

        breakpoints: {
          1200: {
            perPage: 4, // 2 slides en tablets grandes
            gap: '30px',
          },
          991: {
            perPage: 3, // 1 slide en mobile
            gap: '30px',
          },
          767: {
            perPage: 2, // 1 slide en mobile
            gap: '20px',
          },
          480: {
            perPage: 1, // 1 slide en mobile
            gap: '20px',
          }

        }
      });

    newsSplide.mount();
    console.log('News slider initialized successfully');
  } catch (error) {
    console.error('Error initializing news slider:', error);
  }
}

// Inspiration Gallery Slider Functionality
function initInspirationGallerySlider() {
  const gallerySliderElement = document.querySelector('#inspiration-gallery-slider');
  
  if (!gallerySliderElement) {
    console.log('Inspiration gallery slider element not found on this page');
    return;
  }
  
  // Check if Splide is required (element has .splide class)
  if (!gallerySliderElement.classList.contains('splide')) {
    console.log('Inspiration gallery slider element does not require Splide library');
    return;
  }
  
  if (typeof Splide === 'undefined') {
    console.error('Splide library not loaded for inspiration gallery slider');
    console.error('Please verify Splide is enqueued in functions.php');
    return;
  }
  
  console.log('Inspiration gallery slider element found, initializing...');
  
  try {
    const gallerySplide = new Splide('#inspiration-gallery-slider', {
        type: 'slide',
        perPage: 1,
        gap: '0',
        pagination: true,
        arrows: true,
        perMove: 1,
        autoplay: false,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        updateOnMove: true,
        snap: true,
        flickPower: 50,  // Reducido para hacer el drag más sensible
        drag: true,       // Asegura que el drag esté habilitado
        breakpoints: {
          767: {
            gap: '0',
          }
        }
      });

    gallerySplide.mount();
    console.log('Inspiration gallery slider initialized successfully');
  } catch (error) {
    console.error('Error initializing inspiration gallery slider:', error);
  }
}

// Building Revolution Section Functionality
function initBuildingRevolution() {
  const section = document.querySelector('.building-revolution-section');
  const hints = section ? section.querySelectorAll('.interactive-hint') : [];
  const progressFill = section ? section.querySelector('.progress-bar-fill') : null;
  const dynamicImage = document.getElementById('building-revolution-dynamic-image');
  const imageContainer = document.querySelector('.building-revolution-image-container');

  const MOBILE_BREAKPOINT = 991;
  let desktopScrollHandler = null;
  let mobileScrollHandler = null;
  let resizeTimeout;

  function updateImageWidth() {
    if (!imageContainer) {
      return;
    }

    const container = document.querySelector('.building-revolution-section .container');
    if (!container) {
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const rightMargin = viewportWidth - containerRect.right;

    imageContainer.style.marginRight = `-${rightMargin}px`;
  }

  if (!section || hints.length === 0) {
    if (imageContainer) {
      updateImageWidth();
      window.addEventListener('resize', updateImageWidth);
    }
    return;
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function handleMobileProgressBar() {
    const sectionRect = section.getBoundingClientRect();
    const sectionHeight = section.offsetHeight;
    const viewportHeight = window.innerHeight;

    if (sectionRect.bottom > 0 && sectionRect.top < viewportHeight) {
      let progress = 0;

      if (sectionRect.top <= 0) {
        const scrolledPast = Math.abs(sectionRect.top);
        const totalScrollable = Math.max(sectionHeight - viewportHeight, 1);
        progress = Math.min(scrolledPast / totalScrollable, 1);
      }

      if (progressFill) {
        progressFill.style.opacity = progress > 0 ? '1' : '0';
        progressFill.style.height = `${progress * 100}%`;
      }
    } else if (sectionRect.bottom <= 0) {
      if (progressFill) {
        progressFill.style.opacity = '1';
        progressFill.style.height = '100%';
      }
    } else if (progressFill) {
      progressFill.style.opacity = '0';
      progressFill.style.height = '0%';
    }
  }

  function handleBuildingRevolutionScroll() {
    const sectionRect = section.getBoundingClientRect();
    const sectionHeight = section.offsetHeight;
    const viewportHeight = window.innerHeight;
    const denominator = Math.max(sectionHeight - viewportHeight, 1);
    const scrollProgress = Math.max(0, Math.min(1, -sectionRect.top / denominator));
    const sectionInView = sectionRect.top < viewportHeight && sectionRect.bottom > 0;

    if (sectionInView && (sectionRect.top <= 0 || scrollProgress > 0)) {
      const segmentSize = 1 / hints.length;
      let currentActiveIndex = -1;

      hints.forEach((hint, index) => {
        const segmentStart = index * segmentSize;
        const segmentEnd = (index + 1) * segmentSize;

        if (scrollProgress >= segmentStart && (scrollProgress < segmentEnd || index === hints.length - 1)) {
          currentActiveIndex = index;
        }
      });

      hints.forEach((hint, index) => {
        hint.classList.toggle('revealed', index === currentActiveIndex);
      });

      if (currentActiveIndex >= 0 && dynamicImage) {
        const activeHint = hints[currentActiveIndex];
        const newImage = activeHint.getAttribute('data-img');

        if (newImage) {
          const currentSrc = dynamicImage.src.split('/').pop();
          const newSrc = newImage.split('/').pop();

          if (currentSrc !== newSrc) {
            dynamicImage.style.opacity = '0';
            setTimeout(() => {
              dynamicImage.src = newImage;
              dynamicImage.style.opacity = '1';
            }, 250);
          }
        }
      }

      if (progressFill) {
        progressFill.style.opacity = '1';
        progressFill.style.height = `${scrollProgress * 100}%`;
      }
    } else if (sectionRect.top > 0) {
      hints.forEach(hint => hint.classList.remove('revealed'));
      if (progressFill) {
        progressFill.style.opacity = '0';
        progressFill.style.height = '0%';
      }
    }
  }

  function enableMobileMode() {
    hints.forEach(hint => hint.classList.add('revealed'));
    if (!mobileScrollHandler) {
      mobileScrollHandler = handleMobileProgressBar;
      window.addEventListener('scroll', mobileScrollHandler, { passive: true });
    }
    handleMobileProgressBar();
  }

  function disableMobileMode() {
    hints.forEach(hint => hint.classList.remove('revealed'));
    if (mobileScrollHandler) {
      window.removeEventListener('scroll', mobileScrollHandler);
      mobileScrollHandler = null;
    }
    if (progressFill) {
      progressFill.style.opacity = '0';
      progressFill.style.height = '0%';
    }
  }

  function enableDesktopMode() {
    if (!desktopScrollHandler) {
      desktopScrollHandler = handleBuildingRevolutionScroll;
      window.addEventListener('scroll', desktopScrollHandler, { passive: true });
    }
    handleBuildingRevolutionScroll();
  }

  function disableDesktopMode() {
    if (desktopScrollHandler) {
      window.removeEventListener('scroll', desktopScrollHandler);
      desktopScrollHandler = null;
    }
  }

  function syncMode() {
    if (isMobile()) {
      disableDesktopMode();
      enableMobileMode();
    } else {
      disableMobileMode();
      enableDesktopMode();
    }
  }

  updateImageWidth();
  syncMode();

  window.addEventListener('resize', () => {
    updateImageWidth();
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(syncMode, 250);
  });
}

// Wood Panels Parallax Scroll Animation
function initWoodPanelsScroll() {
  const section = document.querySelector('#wood-panels-section');
  
  if (!section) {
    console.log('Wood panels section not found on this page');
    return;
  }
  
  const container = section.querySelector('.wood-panels-container');
  const panels = section.querySelectorAll('.wood-panel-item');
  
  if (panels.length !== 2 || !container) {
    console.log('Wood panels elements not found correctly. Container:', !!container, 'Panels:', panels.length);
    return;
  }
  
  console.log('Wood panels parallax animation initialized');
  
  const panel1 = panels[0];
  const panel2 = panels[1];
  const textOverlay1 = panel1.querySelector('.wood-panel-text-overlay');
  const textOverlay2 = panel2.querySelector('.wood-panel-text-overlay');
  
  // Set initial state
  panel2.style.transform = 'translateY(100%)';
  if (textOverlay1) textOverlay1.style.opacity = '1';
  if (textOverlay2) textOverlay2.style.opacity = '0';
  
  let isAnimating = false;
  let animationProgress = 0;
  
  function updateParallax() {
    const sectionRect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const sectionTop = sectionRect.top;
    const sectionHeight = sectionRect.height;
    
    // Animation starts when section is visible
    // Animation ends later so it's slower
    const animationStart = windowHeight * 0.5; // Starts earlier (was 0.35)
    const animationEnd = -sectionHeight * 0.6; // Slower animation
    const animationRange = animationStart - animationEnd;
    
    // Calculate progress (0 to 1)
    let progress = 0;
    if (sectionTop <= animationStart && sectionTop >= animationEnd) {
      progress = (animationStart - sectionTop) / animationRange;
      progress = Math.max(0, Math.min(1, progress));
    } else if (sectionTop < animationEnd) {
      progress = 1;
    }
    
    // Apply transforms
    if (progress > 0) {
      isAnimating = true;
      
      // Both images move together - second pushes first upward
      // Panel 2 moves from 100% (below) to 0% (center)
      const panel2TranslateY = (1 - progress) * 100;
      panel2.style.transform = `translateY(${panel2TranslateY}%)`;
      
      // Panel 1 moves from 0% (center) to -100% (above)
      const panel1TranslateY = -progress * 100;
      panel1.style.transform = `translateY(${panel1TranslateY}%)`;
      
      // Control text visibility - gradual fade transition
      if (textOverlay1 && textOverlay2) {
        // Text 1 fades out from 30% to 50% of progress
        if (progress < 0.3) {
          textOverlay1.style.opacity = '1';
        } else if (progress >= 0.3 && progress <= 0.5) {
          const fadeOutProgress = (progress - 0.3) / 0.2; // 0 to 1
          textOverlay1.style.opacity = String(1 - fadeOutProgress);
        } else {
          textOverlay1.style.opacity = '0';
        }
        
        // Text 2 fades in from 50% to 70% of progress
        if (progress < 0.5) {
          textOverlay2.style.opacity = '0';
        } else if (progress >= 0.5 && progress <= 0.7) {
          const fadeInProgress = (progress - 0.5) / 0.2; // 0 to 1
          textOverlay2.style.opacity = String(fadeInProgress);
        } else {
          textOverlay2.style.opacity = '1';
        }
      }
      
    } else {
      // Reset to initial state
      panel1.style.transform = 'translateY(0%)';
      panel2.style.transform = 'translateY(100%)';
      if (textOverlay1) textOverlay1.style.opacity = '1';
      if (textOverlay2) textOverlay2.style.opacity = '0';
      isAnimating = false;
    }
  }
  
  // Use requestAnimationFrame for smooth animation
  let ticking = false;
  
  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }
  
  function handleScroll() {
    requestTick();
    ticking = false;
  }
  
  window.addEventListener('scroll', handleScroll, { passive: true });
  updateParallax(); // Initial check
}

// Initialize HLS videos with Bunny Stream
function initHLSVideos() {
  // Check if HLS.js is loaded
  if (typeof Hls === 'undefined') {
    console.warn('HLS.js not loaded yet, waiting...');
    setTimeout(initHLSVideos, 100);
    return;
  }
  
  loadAllHLSVideos();
}

function loadAllHLSVideos() {
  // Find all videos with HLS sources
  const videos = [
    { id: 'hero-video', src: 'https://vz-c5c25fac-779.b-cdn.net/6a4ddf21-a996-4ec4-8051-00cc8755ea19/playlist.m3u8' },
    { id: 'media-news-video', src: 'https://vz-c5c25fac-779.b-cdn.net/257b03a5-c442-49c2-997c-1236762e0bb8/playlist.m3u8' }
  ];
  
  console.log('Loading HLS videos...');
  
  videos.forEach(function(videoData) {
    const video = document.getElementById(videoData.id);
    
    if (!video) {
      console.log('Video element not found:', videoData.id);
      return;
    }
    
    console.log('Found video element:', videoData.id);
    
    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 90,
        maxBufferLength: 30,
        maxMaxBufferLength: 60
      });
      
      hls.loadSource(videoData.src);
      hls.attachMedia(video);
      
      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        video.play().catch(function(error) {
          console.log('Autoplay prevented for ' + videoData.id + ':', error);
        });
      });
      
      hls.on(Hls.Events.ERROR, function(event, data) {
        if (data.fatal) {
          switch(data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log('Network error for ' + videoData.id + ', trying to recover...');
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log('Media error for ' + videoData.id + ', trying to recover...');
              hls.recoverMediaError();
              break;
            default:
              console.log('Fatal error for ' + videoData.id + ', cannot recover');
              hls.destroy();
              break;
          }
        }
      });
      
      console.log('HLS video loaded successfully: ' + videoData.id);
    } 
    // HLS.js not supported but native HLS is (Safari, iOS)
    else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = videoData.src;
      video.addEventListener('loadedmetadata', function() {
        video.play().catch(function(error) {
          console.log('Autoplay prevented for ' + videoData.id + ':', error);
        });
      });
      console.log('Native HLS video loaded: ' + videoData.id);
    }
  });
}

